import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  const pages = [];
  const delta = 2;
  const left = currentPage - delta;
  const right = currentPage + delta;

  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || (i >= left && i <= right)) {
      pages.push(i);
    }
  }

  const withEllipsis = [];
  let prev = null;
  for (const page of pages) {
    if (prev !== null && page - prev > 1) {
      withEllipsis.push('...');
    }
    withEllipsis.push(page);
    prev = page;
  }

  return (
    <div style={styles.wrapper}>
      <button
        style={{ ...styles.btn, ...(currentPage === 1 ? styles.disabled : {}) }}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <i className="fa fa-chevron-left" />
      </button>

      {withEllipsis.map((item, idx) =>
        item === '...' ? (
          <span key={`ellipsis-${idx}`} style={styles.ellipsis}>…</span>
        ) : (
          <button
            key={item}
            style={{ ...styles.btn, ...(item === currentPage ? styles.active : {}) }}
            onClick={() => onPageChange(item)}
          >
            {item}
          </button>
        )
      )}

      <button
        style={{ ...styles.btn, ...(currentPage === totalPages ? styles.disabled : {}) }}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <i className="fa fa-chevron-right" />
      </button>

      <span style={styles.info}>
        หน้า {currentPage} จาก {totalPages}
      </span>
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginTop: 16,
    flexWrap: 'wrap',
  },
  btn: {
    minWidth: 36,
    height: 36,
    padding: '0 10px',
    border: '1px solid #e5e7eb',
    borderRadius: 6,
    background: '#fff',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 500,
    color: '#374151',
    transition: 'all 0.15s',
  },
  active: {
    background: '#1e3a5f',
    borderColor: '#1e3a5f',
    color: '#fff',
  },
  disabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
  ellipsis: {
    padding: '0 4px',
    color: '#9ca3af',
    fontSize: 14,
  },
  info: {
    marginLeft: 8,
    fontSize: 13,
    color: '#6b7280',
  },
};

export default Pagination;
